__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "_vk_cloud_lk_host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@vk-tech-solar/config", "0.97.10", () => (Promise.all([__webpack_require__.e(409), __webpack_require__.e(580), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(5580))))));
			register("@vk-tech-solar/core", "0.97.10", () => (Promise.all([__webpack_require__.e(409), __webpack_require__.e(931)]).then(() => (() => (__webpack_require__(1931))))));
			register("@vk-tech-solar/dev-tools-utils", "0.97.10", () => (Promise.all([__webpack_require__.e(170), __webpack_require__.e(11), __webpack_require__.e(964), __webpack_require__.e(418), __webpack_require__.e(976)]).then(() => (() => (__webpack_require__(11))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(230).then(() => (() => (__webpack_require__(2230))))));
			register("react", "18.3.1", () => (__webpack_require__.e(653).then(() => (() => (__webpack_require__(1653))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(437), __webpack_require__.e(400)]).then(() => (() => (__webpack_require__(8437))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};